import initAppearAnim from './utils/appear-anim';
import initNav from './components/navigation';
import { initYoutube } from './components/youtube';
import initDropdowns from './components/dropdowns';
import initMaillagePodcasts from './blocks/maillage-podcasts';
import initMaillageTypeMetiers from './blocks/maillage-types-metier';


// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Utils
initAppearAnim();

// Modules
initNav();
initDropdowns();

// Blocks
initMaillageTypeMetiers();
initMaillagePodcasts();

//TEMPLATE PARTS

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initYoutube();

